<template>
  <div class="q-pa-lg">
    <div class="row justify-between items-start">
      <div class="row justify-between">
        <h1>Счета <span class="data-rows-number">{{ billsTotal }}</span></h1>
        <bonus-view/>
        <balance-view/>
      </div>
    </div>
    <project-bills-list
        v-if="ownerId"
        ref="projectBillsList"
    />
    <div v-else>
      Для работы со счетами необходимо указать
      <router-link :to="`/projects/${this.$route.params.id}#client`">клиента</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProjectBillsList from '@/ProjectBillsList'
import BalanceView from './BalanceView'
import BonusView from './BonusView.vue'

export default {
  name: 'ProjectBillsView',

  components: {
    BalanceView,
    ProjectBillsList,
    BonusView,
  },

  computed: mapGetters({
    billsTotal: 'billsList/total',
    ownerId: 'project/ownerId',
  }),
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/ProjectBillsView.vue